// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"ce10b586","311":"34153b7e","455":"ad39ae66","971":"41c36259","977":"f7517653"}[chunkId] + ".chunk.js";
};